var validatePass = (rule, value, callback) => {
  let phone = /^(13|14|15|16|17|18|19)[0-9]\d{8}$/;
  if (value === "") {
    callback(new Error("请填写手机号码"));
  } else {
    if (!phone.test(value)) {
      callback([new Error("请输入正确的手机号")]);
    }
    callback();
  }
};
var validateEmail = (rule, value, callback) => {
  var re = /^\w+@[a-z0-9]+\.[a-z]{2,4}$/;
  if (value === "") {
    callback(new Error("请填写邮箱"));
  } else {
    if (!re.test(value)) {
      callback([new Error("请输入正确的邮箱格式")]);
    }
    callback();
  }
};
var validateSfzh = (rule, value, callback) => {
  var sf = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (value === "") {
    callback(new Error("请输入身份证号码"));
  } else if (!sf.test(value)) {
    callback(new Error("请输入正确的身份证号码"));
  } else {
    callback();
  }
};



var utils = {
  time: '2021年6月22日~2021年12月31日',
  formDate: {
    province: {
      'name': '省份', 'value': '', option: 'province', 'showSelect': true, 'select':
      [
        '全部',
        '北京',
        '福建',
        '辽宁',
        '天津',
        '四川',
        '江苏',
        '新疆',
        '金航联',
        '河北',
        '黑龙江',
        '贵州',
        '云南',
        '安徽',
        '甘肃',
        '海南',
        '重庆',
        '西藏',
        '认证中心',
        ]
    },
    WorkName: {
      'name': '姓名', 'value': '', 'placeholder': '请填写', 'option': 'userName', 'showSelect': false
    },
    Cardid: {
      'name': '证件号码', 'value': '', 'placeholder': '请填写', 'option': 'userName', 'showSelect': false
    },
    sqlb: {
      'name': '申请类别', 'value': '', 'option': 'sqlb', 'showSelect': true, 'select': ['‌病假','事假‌','婚假‌','产假‌','丧假','年假','调休','工伤','护理假','其他']
    },
    Sex: {
      'name': '性别', 'value': '', 'option': 'sex', 'showSelect': true, 'select': ['男', '女']
    },
    NATION: {
      'name': '民族', 'value': '', option: 'NATION', 'showSelect': true, 'select':
        ['汉族', '少数民族', '外籍'],
    },
    MEDULEVEL: {
      'name': '学历', 'value': '', option: 'education', 'showSelect': true, 'select':
        // ['博士研究生','硕士研究生','本科','大专','中专','高中','初中'],
        ['博士', '硕士', '本科', '大专', '中专'],
    },
    MEDUSPEC: {
      'name': '专业', 'value': '', option: 'education', 'showSelect': true, 'select': ['药学', '中药学'],
    },
    Day:{
      'name': '天数', 'value': '', option: 'Day', 'showSelect': true, 'select': ['0天','1天', '2天','3天', '4天','5天', '6天','7天', '8天','9天','10天'],
    },
    many:{
      'name': '张数', 'value': '', option: 'many', 'showSelect': true, 'select': ['1张', '2张','3张', '4张','5张', '6张','7张', '8张','9张','10张','11张', '12张','13张', '14张','15张', '16张','17张', '18张','19张', '20张'],
    },
    gs:{
      'name': '张数', 'value': '', option: 'gs', 'showSelect': true, 'select': ['0张','1张', '2张','3张', '4张','5张', '6张','7张', '8张','9张','10张','11张', '12张','13张', '14张','15张', '16张','17张', '18张','19张', '20张'],
    },
    nf:{
      'name': '年份', 'value': '', option: 'nf', 'showSelect': true, 'select': ['1年', '2年','3年', '4年','5年', '6年','7年', '8年','9年','10年','11年', '12年','13年', '14年','15年', '16年','17年', '18年','19年', '20年','21年','22年', '23年','24年','25年', '26年','27年','28年', '29年','30年','31年', '32年','33年','34年', '35年','36年','37年', '38年','39年','40年', '41年','42年','43年', '44年','45年','46年', '47年','48年','49年', '50年',],
    },
    bus:{
      'name': '交通工具', 'value': '', option: 'bus', 'showSelect': true, 'select': ['出租车','飞机','火车','私家车','地铁'],
    },
    Age:{
      'name': '年龄', 'value': '', option: 'education', 'showSelect': true, 'select': ['1', '2','3', '4','5', '6','7', '8','9', '10','11', '12','13', '14','15', '16','17', '18','19', '20','21', '22','23', '24','25', '26','27', '28','29', '30','31', '32', '33','34', '35','36', '37','38', '39','40', '41','42', '43','44', '45', '46','47', '48','49', '50','51', '52','53', '54','55', '56','57', '58', '59','60', '61','62', '63','64', '65','66', '67','68', '69','70', '71', '72','73', '74','75', '76','77', '78','79', '80','81', '82','83', '84', '85','86', '87','88', '89','90', '91','92', '93','94', '95','96', '97', '98','99', '100'],
    },
    sort: {
      'name': '证书类型', 'value': '', option: 'certificate', 'showSelect': true, 'select': ['执业药师', '从业药师'],
    },
    ExtentOne: {
      'name': '执业类别', 'value': '', option: 'operation', 'showSelect': true, 'select': ['药学', '中药学', '药学和中药学'],
    },
    QualiCode: {
      'name': '资格证书号或管理号', 'value': '', option: 'operation', 'showSelect': false, type: 'date'
    },
    ATTEYEAR: {
      'name': '考取年份', 'value': '', 'placeholder': '请填写，如：考试年月', option: 'time', 'showSelect': false
    },
    zQualiCode: {
      'name': '资格证书号或管理号', 'value': '', option: 'operation', 'showSelect': false, type: 'date'
    },
    zATTEYEAR: {
      'name': '中药证书批准时间', 'value': '', 'placeholder': '请填写', option: 'time', 'showSelect': false
    },
    NATIVEPLACE: {
      'name': '属地（市）', 'value': '', 'placeholder': '请填写', 'option': 'userName', 'showSelect': true, 'select': [
        '拉萨市', '日喀则市', '昌都市', '林芝市', '山南市', '那曲市', '阿里地区']
    },
    ExtentTwo: {
      'name': '执业范围', 'value': '', option: 'operatorScope', 'showSelect': true, 'select':
        ['生产', '批发', '零售', '使用', '机关', '院校', '检验', '无'],
    },
    WorkUnit: {
      'name': '工作单位', 'value': '', 'placeholder': '请填写', option: 'company', 'showSelect': false
    },
    HANDSETPHONE: {
      'name': '手机号码', 'value': '', 'placeholder': '请填写', option: 'mobilePhone', 'showSelect': false
    },
    MEDUSCHOOL: {
      'name': '毕业学校', 'value': '', 'placeholder': '请填写', option: 'school', 'showSelect': false
    },
    MEDUTIME: {
      'name': '毕业时间', 'value': '', 'placeholder': '请填写', option: 'graduation', 'showSelect': true, type: 'date'
    },
    zxsj: {
      'name': '注销时间', 'value': '', 'placeholder': '请填写', option: 'graduation', 'showSelect': true, type: 'date'
    },
    rdnf: {
      'name': '认定年份', 'value': '', 'placeholder': '请填写', option: 'graduation', 'showSelect': true, type: 'date'
    },
    technicOne: {
      'name': '职称', 'value': '', option: 'specialLevel', 'showSelect': true, 'select': ['正高级', '副高级', '中级', '初级', '员级', '无'],
    },
    JOBLEVEL: {
      'name': '职务', 'value': '', 'placeholder': '请填写', option: 'station', 'showSelect': false
    },
    WorkStat: {
      'name': '从事岗位', 'value': '', 'placeholder': '请填写', option: 'station', 'showSelect': false
    },
    address: {
      'name': '通讯地址', 'value': '', 'placeholder': '请填写', option: 'graduation', 'showSelect': false
    },
    postalcode: {
      'name': '邮政编码', 'value': '', 'placeholder': '请填写', option: 'phone', 'showSelect': false
    },
    LINKPHONE: {
      'name': '单位电话', 'value': '', 'placeholder': '请填写', option: 'phone', 'showSelect': false
    },
    email: {
      'name': 'E-mail', 'value': '', 'placeholder': '请填写', option: 'email', 'showSelect': false
    },
    grjl: {
      'name': '个人简历', 'value': '', 'placeholder': '请填写', option: 'email', 'showSelect': false, typpe: 'textarea'
    },
    byzpic: {
      'name': '毕业证书照片', 'value': '', option: 'specialLevel', 'showSelect': true, 'select': ['正高级', '副高级', '中级', '初级', '无'],
    },
    zgzpic: {
      'name': '资格证书照片', 'value': '', option: 'specialLevel', 'showSelect': true, 'select': ['正高级', '副高级', '中级', '初级', '无'],
    },
    POLITICS: {
      'name': '政治面貌', 'value': '', 'placeholder': '请填写', option: 'email', 'showSelect': true, 'select': ['党员',
        '团员', '民主人士', '群众']
    },
    zhuangtai: {
      'name': '执业状态', 'value': '', 'placeholder': '请填写', option: 'email', 'showSelect': true, 'select': []
    },
    zcdw: {
      'name': '注册单位', 'value': '', 'placeholder': '请填写', option: 'phone', 'showSelect': false
    },
    zzzbh: {
      'name': '注册证号', 'value': '', 'placeholder': '请填写', option: 'phone', 'showSelect': false
    },
    REGISTERTIME: {
      'name': '注销时间', 'value': '', 'placeholder': '请填写', option: 'time', 'showSelect': false
    },
    jg: {
      'name': '籍贯', 'value': '', 'placeholder': '请填写', option: 'time', 'showSelect': false
    },
    stzw: {
      'name': '社团职务', 'value': '', 'placeholder': '请填写', option: 'time', 'showSelect': false
    },

  },
  validatePass,
  validateEmail,
  validateSfzh,
  rules: {
    WorkName: [{ required: true, message: "请填写姓名", trigger: "blur" }],
    Sex: [{ required: true, message: "请选择性别", trigger: "change" }],
    cardid: [
      // { required: true, message: "请填写身份证号", trigger: "blur" },
      { required: true, validator: validateSfzh, trigger: "blur" },
    ],
    NATION: [{ required: true, message: "请选择民族", trigger: "change" }],
    NATIVEPLACE: [
      { required: true, message: "请选择属地", trigger: "change" },
    ],
    QualiCode: [
      {
        required: true,
        message: "请填写资格证书或管理号",
        trigger: "blur",
      },
    ],
    sort: [
      { required: true, message: "请选择证书类别", trigger: "change" },
    ],
    zzmm:[
      { required: true, message: "请选择政治面貌", trigger: "change"}
    ],
    ATTEYEAR: [
      { required: true, message: "请填写考取年份", trigger: "blur" },
    ],
    Address: [
      { required: true, message: "请填写通讯地址", trigger: "blur" },
    ],
    ExtentOne: [
      { required: true, message: "请选择执业类别", trigger: "change" },
    ],
    HANDSETPHONE: [
      { required: true, validator: validatePass, trigger: "blur" },
    ],
    MEDULEVEL: [
      { required: true, message: "请选择学历", trigger: "change" },
    ],
    MEDUSPEC: [
      { required: true, message: "请选择专业", trigger: "change" },
    ],
    MEDUSCHOOL: [
      { required: true, message: "请填写毕业院校", trigger: "blur" },
    ],
    JOBLEVEL: [
      { required: true, message: "请选择职称", trigger: "change" },
    ],
    ExtentTwo: [
      { required: true, message: "请选择执业范围", trigger: "change" },
    ],
    LINKPHONE: [
      { required: true, message: "请填写单位电话", trigger: "blur" },
    ],
    postalcode: [
      { required: true, message: "请填写邮政编码", trigger: "blur" },
    ],
    WorkUnit: [
      { required: true, message: "请填写工作单位", trigger: "blur" },
    ],
    Company:[
      { required: true, message: "请填写工作单位及职务", trigger: "blur" },
    ],
    email: [
      { required: true, validator: validateEmail, trigger: "blur" },
    ],
    Birth:[
      {required: true, message: "请选择出生年月", trigger: "blur"}
    ],
    WorkTime:[
      {required: true, message: "请选择参加工作时间", trigger: "blur"}
    ],
    Salary:[
      {required: true, message: "请输入薪资要求", trigger: "blur"}
    ],
    Specialty:[
      {required: true, message: "请输入专业技能和特长", trigger: "blur"}
    ],
    Major:[
      {required: true, message: "请输入专业技术职称", trigger: "blur"}
    ],
    year:[
      {required: true, message: "请输入年龄", trigger: "blur"}
    ],
    gw:[
      {required: true, message: "请输入求职岗位", trigger: "blur"}
    ],
  },




  changefocus() {
    let u = navigator.userAgent, app = navigator.appVersion;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    if (isAndroid) {
      setTimeout(function () {
        document.activeElement.scrollIntoViewIfNeeded();
        document.activeElement.scrollIntoView();
      }, 500);
    }
  },
  changeBlur() {
    let u = navigator.userAgent, app = navigator.appVersion;
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isIOS) {
      setTimeout(() => {
        const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 200)
    }
  },
  IEVersion() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    if (isIE) {
      return false
    } else if (isEdge) {
      return false//edge
    } else if (isIE11) {
      return true; //IE11  
    } else {
      return true;//不是ie浏览器
    }
  },
  enrollStr(str) {
    let str2 = ''
    if (str === 'face') {
      str2 = '函授'
    } else if (str === 'online') {
      str2 = '网络'
    } else if (str === 'repair') {
      str2 = '补修'
    }
    return str2
  },
  clear() {
    window.localStorage.clear();
  },
  token: {
    set(token) {
      window.localStorage.setItem("token", token);
    },
    get() {
      return window.localStorage.getItem('token');
    },
    remove() {
      window.localStorage.removeItem('token')
    }
  },
  news: {
    set(str) { // 获取详细的新闻
      window.localStorage.setItem("newsIndex", str);
    },
    get() {
      return window.localStorage.getItem('newsIndex');
    },
    setList(str) {
      window.localStorage.setItem("Keyword", str);
    },
    getList() {
      return window.localStorage.getItem("Keyword");
    }
  },
  userName: {
    set(str) { // 获取详细的新闻
      window.localStorage.setItem("userName", str);
    },
    get() {
      return window.localStorage.getItem('userName');
    },
  },
  courseId: {
    set(str) { // 获取详细的新闻
      window.localStorage.setItem("courseNum", str);
    },
    get() {
      return window.localStorage.getItem('courseNum');
    },
  },
  enroll: {
    set(str) { // 获取详细的新闻
      window.localStorage.setItem("enrollName", str);
    },
    get() {
      return window.localStorage.getItem('enrollName');
    },
  },
  info: {
    set(str) { // 获取详细的新闻
      window.localStorage.setItem("info", str);
    },
    get() {
      return window.localStorage.getItem('info');
    },
  },
  quwstions2020: [
  ]

}

export default utils


// WEBPACK FOOTER //
// ./src/utils/index.js